import { forEach, cloneDeep, find, isEmpty, filter, isNil, map, includes } from 'lodash';

class Graph {
  constructor(graph) {
    // TODO: add checks for empty nodes and links. throw error?
    this.vertices = [];
    this.edges = [];
    this.adjacencyList = new Map();
    forEach(graph.nodes, vertex => {
      this.addVertex(vertex);
    });
    forEach(graph.links, edge => {
      this.addEdge(edge.source, edge.target);
    });
    this.dfs();
  }

  addVertex(vertex) {
    // initialize the adjacent list with an empty array
    this.vertices.push(vertex);
    this.adjacencyList.set(vertex.id, []);
    this.dfs();
  }

  addEdge(sourceVertexId, targetVertexId) {
    // get the list for vertex source and put the
    // vertex target denoting edge between source and target
    this.edges.push({ source: sourceVertexId, target: targetVertexId });
    this.adjacencyList.get(sourceVertexId).push(targetVertexId);
    this.dfs();
  }

  // Main DFS method
  dfs() {
    this.dfsVertices = cloneDeep(this.vertices);
    this.topoSortedVertices = [];

    forEach(this.dfsVertices, vertex => {
      const updateVertex = vertex;
      updateVertex.visited = false;
      updateVertex.pi = null;
      updateVertex.color = 'white';
    });
    this.dfsTime = 0;
    forEach(this.dfsVertices, vertex => {
      if (!vertex.visited) {
        this.dfsVisit(vertex);
      }
    });

    return this.topoSortedVertices;
  }

  // Recursive function which processes and explores
  // all the adjacent vertices of the vertex with which it is called
  dfsVisit(vertex) {
    const updateVertex = vertex;
    this.dfsTime += 1;
    updateVertex.discoveryTime = this.dfsTime;
    updateVertex.visited = true;
    updateVertex.color = 'gray';

    const neighboursIds = this.adjacencyList.get(vertex.id);

    forEach(neighboursIds, neighbourId => {
      const neighbour = find(this.dfsVertices, ['id', neighbourId]);
      if (!neighbour.visited) {
        neighbour.pi = updateVertex.id;
        this.dfsVisit(neighbour);
      }
    });

    updateVertex.color = 'black';
    this.dfsTime += 1;
    updateVertex.finishedTime = this.dfsTime;
    this.topoSortedVertices.unshift(updateVertex);
  }

  isRoot(vertexToCheck) {
    if (isEmpty(this.topoSortedVertices)) {
      this.dfs();
    }
    const vertexInTopoSearch = find(this.topoSortedVertices, ['id', vertexToCheck.id]);

    if (isNil(vertexInTopoSearch.pi)) {
      return true;
    }
    return false;
  }

  isLeaf(vertexToCheck) {
    if (isEmpty(this.adjacencyList)) {
      throw new Error('no adjancency list');
    }
    const neighboursIds = this.adjacencyList.get(vertexToCheck.id);
    if (isEmpty(neighboursIds)) {
      return true;
    }
    return false;
  }

  getRoots() {
    if (isEmpty(this.topoSortedVertices)) {
      this.dfs();
    }
    const graphRootsTopoSearch = filter(this.topoSortedVertices, vertex => {
      if (isNil(vertex.pi)) {
        return true;
      }
      return false;
    });
    const graphRootsIds = map(graphRootsTopoSearch, root => root.id);
    const graphRoots = filter(this.vertices, vertex => {
      return includes(graphRootsIds, vertex.id);
    });
    return graphRoots;
  }

  getLeaves() {
    if (isEmpty(this.adjacencyList)) {
      throw new Error('no adjancency list');
    }
    const graphLeavesIds = [];
    this.adjacencyList.forEach((neighboursIds, vertexId) => {
      if (isEmpty(neighboursIds)) {
        graphLeavesIds.push(vertexId);
      }
    });
    const graphLeaves = filter(this.vertices, vertex => {
      return includes(graphLeavesIds, vertex.id);
    });
    return graphLeaves;
  }
}

export default Graph;
